module.exports = __webpack_public_path__ + "img/C3.c0145e13.png";